import http from '@/axios/http'
//信号值获取
export function listRssi(data) {
    if (data.gid == '') {
        delete data.gid
    }
    return http({
        url: '/api/rssiManager/listRssi',
        method: 'post',
        data
    })
}
export function mocklistRssi(data) {
    return http({
        url: 'https://easy-mock.com/mock/5d53c48c61e7b9395e52a836/api/rssiManager/listRssi/api/rssiManager/listRssiYear',
        method: 'post',
        data
    })
}